import Modal from '../../..';
import Form from '../../../../Form';
import useStore from '../../../../Hooks/useStore';


const ModalLogisticOriginDelete = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    invoice: { setInvoice },
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.deleteLogisticOrigins');
  const onClose = () => {
    closeSingleModal('deleteLogisticOrigins');
    setInvoice('selected.logisticOrigin', -1);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Remover logística origem"
      height={'auto'}
      width={'30vw'}
    >
      <Form.Export.Logistic.Origin.Delete />
    </Modal>
  );
};

export default ModalLogisticOriginDelete;
